import React from "react";
import { Checkbox, TextField, Typography, Stack, FormControlLabel, Box } from "@mui/material";
import { useSelector } from "react-redux";

export const ClientTimesheetUDFieldComponent = ({ udFields = [], onChange, index }) => {
  const { selectedClientData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor || "#1976d2";

  if (!udFields || udFields.length === 0) return null;

  return (
    <Stack sx={{ gap: 1, overflowY: "auto", scrollbarWidth: "none" }}>
      {udFields.map((field, i) => {
        const isCheckbox =
          field?.udFieldTypeName === "Checkbox" ||
          field?.udFieldTypeId === 1 ||
          field?.fieldTypeId === 1 ||
          field?.fieldTypeName === "Checkbox";

        const label = field?.udFieldLabel ?? field?.fieldLabel ?? field?.label ?? "";

        if (isCheckbox) {
          const isChecked = field?.value !== undefined && field?.value !== ""
            ? (field.value === "true" || field.value === true)
            : (field?.fieldDefaultValue === "true" || field?.fieldDefaultValue === true);

          return (
            <FormControlLabel
              key={i}
              onChange={(e) => onChange(e, index, i)}
              control={
                <Checkbox
                  checked={isChecked}
                  sx={{
                    "&.Mui-checked": {
                      color: CLIENT_ACCENT_COLOR
                    }
                  }}
                />
              }
              label={
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {label}
                </Typography>
              }
            />
          );
        } else {
          const textValue = field?.value !== undefined ? field.value : (field?.fieldDefaultValue || "");
          return (
            <Box key={i} sx={{ width: "100%" }}>
              <Typography variant="body2" sx={{ color: "text.secondary" }} gutterBottom>
                {label}
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={textValue}
                onChange={(e) => onChange(e, index, i)}
                sx={{
                  backgroundColor: "#e4e4e4",
                  borderRadius: "10px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none"
                  }
                }}
              />
            </Box>
          );
        }
      })}
    </Stack>
  );
};
